<template>
<el-form-item prop="hgt1" label="高度" :rules="[{
  required: true,
  message: '请输入高度'
}]">
  <div style="width:100%;height:32px;"></div>
  <div style="width:100%;">
    <el-checkbox-group v-model="hgts" :disabled="isCustomHeight" @change="onHeightChange">
      <el-checkbox
        v-for="height in heights"
        :key="height.value"
        :label="height.value"
      >{{height.label}}</el-checkbox>
    </el-checkbox-group>

    <div style="margin-top:10px;">
      <el-checkbox v-model="isCustomHeight" class="custom-height-checkbox" @change="onIsCustomHeightChange">
        <el-input v-model="hgt1Input" type="number" :disabled="!isCustomHeight" style="width:233px;" @change="onHeightInputChange">
          <template #append>米</template>
        </el-input>
      </el-checkbox>
    </div>
  </div>
</el-form-item>
</template>

<script>
import Option from './Option'
import BaseHySplit from './BaseHySplit'

const {heights} = Option

export default {
  name: 'HeightCheckboxGroup',
  extends: BaseHySplit,
  data: () => ({
    hgts: heights.map(height => height.value),
    isCustomHeight: false,
    hgt1Input: 2000
  }),
  computed: {
    heights: () => heights
  },
  methods: {
    onHeightChange (hgts) {
      hgts = [...hgts].sort((a, b) => a - b)
      let {model} = this
      model.hgt1 = model.hgt2 = model.hgt3 = null

      hgts.reduce((model, hgt, index) => {
        model[`hgt${index + 1}`] = hgt
        return model
      }, model)
    },
    onHeightInputChange () {
      let hgt1Input = parseInt(this.hgt1Input)

      if (hgt1Input) {
        this.onHeightChange([hgt1Input])
      } else {
        let {model} = this
        model.hgt1 = ''
      }
    },
    onIsCustomHeightChange (isCustomHeight) {
      isCustomHeight ? this.onHeightInputChange() : this.onHeightChange(this.hgts)
    }
  },
  created () {
    let {model} = this

    this.hgts.forEach((height, index) => {
      model[`hgt${index + 1}`] = height
    })
  }
}
</script>

<style lang="scss" scoped>
.custom-height-checkbox {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/04HYSPLIT/HeightCheckboxGroup.vue